import { getSignedPatientPhotoUrl } from '@services/api/patient.api'

const fileIcons: Record<string, string> = {
  pdf: 'mgc_pdf_fill',
  doc: 'mgc_file_fill',
  docx: 'mgc_file_fill',
  txt: 'mgc_file_fill',
  svg: 'mgc_file_fill',
  png: 'mgc_pic_fill',
  jpg: 'mgc_pic_fill',
  jpeg: 'mgc_pic_fill',
  gif: 'mgc_pic_fill',
  mp4: 'mgc_video_line',
  mov: 'mgc_video_line',
  avi: 'mgc_video_line',
  mkv: 'mgc_video_line',
}

export const getFileIcon = (fileName: string): string => {
  const extension = fileName.split('.').pop()?.toLowerCase() || ''
  return fileIcons[extension] || 'mgc_file_fill'
}

const normalizeDevPublicUrl = (raw?: string): string | undefined => {
  if (!raw) return undefined
  const parts = raw.split(/public[\\/]/i)
  if (parts.length > 1) {
    return '/' + parts[1].replace(/\\/g, '/')
  }
  return raw
}

const normalizeProdUrl = async (url: string): Promise<string> => {
  const res = await getSignedPatientPhotoUrl(url)
  return res.data.url || url
}

export const fileFromUrl = async (
  url: string,
  filename: string,
  mimeType?: string,
): Promise<File> => {
  url = await normalizeProdUrl(url)
  const res = await fetch(url)
  const blob = await res.blob()
  return new File([blob], filename, { type: mimeType || blob.type })
}

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string
      resolve(result.split(',')[1])
    }
    reader.onerror = (error) => reject(error)
    reader.readAsDataURL(file)
  })
}
